import { useContext } from "react";

import { useTranslation } from "react-i18next";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import Dialog from "components/DesignComponents/Dialog";
import AuthContext from "context/auth/authContext";
import { USER_ACCESS_LEVELS } from "shared/types/enums";
import { DialogHandler } from "shared/types/interfaces";

import Account from "./Account";
import Security from "./Security";

const SecurityAndAccount = ({ isOpen, close }: DialogHandler) => {
    const { user } = useContext(AuthContext);

    const { t } = useTranslation();

    const isUserAccessLevel = user?.access_level === USER_ACCESS_LEVELS.User;

    return (
        <Dialog
            open={isOpen}
            close={close}
            isTitleSeparator
            isActionsSeparator
            extendToMaxWidth
            title={t("Security##security and account")}
            description={t("Security##description")}
            actions={
                <Button
                    fullWidth
                    color={BUTTON_COLORS.Secondary}
                    size={BUTTON_SIZES.Normal}
                    variant={BUTTON_VARIANTS.TextOnly}
                    onClick={close}
                >
                    {t("Button##close")}
                </Button>
            }
        >
            <Security />

            {isUserAccessLevel && <Account />}
        </Dialog>
    );
};

export default SecurityAndAccount;
